import { render, staticRenderFns } from "./Statuscomercial.vue?vue&type=template&id=50b2661a&scoped=true"
import script from "./Statuscomercial.vue?vue&type=script&lang=js"
export * from "./Statuscomercial.vue?vue&type=script&lang=js"
import style0 from "./Statuscomercial.vue?vue&type=style&index=0&id=50b2661a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b2661a",
  null
  
)

export default component.exports